import { render, staticRenderFns } from "./EnumBlock.vue?vue&type=template&id=5fd8daf2&scoped=true&lang=pug"
import script from "./EnumBlock.vue?vue&type=script&lang=ts"
export * from "./EnumBlock.vue?vue&type=script&lang=ts"
import style0 from "./EnumBlock.vue?vue&type=style&index=0&id=5fd8daf2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd8daf2",
  null
  
)

export default component.exports